/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from './styles/Header.styled.js';
import { DisplaySection } from './styles/DisplaySection.styled.js';
import ArticleShowcase from './ArticleShowcase.js';
// import rade_color from './assets/rade-color.png';
import About from './assets/About.jpg';
import Facilities from './assets/Facilities.jpg';

import { AboutMe } from './styles/AboutMe.styled.js';
import { WhyChooseUs } from './styles/WhyChooseUs.styled.js';
import { MapSection } from './styles/MapSection.styled.js';
import { Footer } from './styles/Footer.styled.js';
// import logo from './assets/rade-white.png';
import logo from './assets/rj.png';
import professional from './assets/professional-icon.svg';
import custom from './assets/custom-icon.svg';
import price from './assets/price.svg';

const Home = () => {
  const [isClick, setIsClick] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [isNavVisible, setIsNavVisible] = useState(false); // Track navigation visibility

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };
  return (
    <>
      <Header>
        <div id="header_wrap">
          <div className="bg"></div>
          <div className="header_top">
            <div className="container">
              <div className="header_top_inner flex">
                <div className="top_left_content">
                  <div className="header_top_left">
                    <div className="email">
                      <a href="mailto:info@radeintegratedservices.co.uk">
                        <i className="fa-regular fa-envelope"></i>
                      </a>
                      <p>
                        <label id="2">
                          If you have any queries
                          <br />
                          info@radeintegratedservices.co.uk
                        </label>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="header_top_right">
                  <div className="right-item time">
                    <p>Opening Hours: 9:00AM - 5:00PM</p>
                  </div>
                  <div className="right-item top_right_button">
                    <a href="/contact" target="_self">
                      Get a Quote
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="site_header">
            <div className="container">
              <div className="row">
                <div className="site_branding">
                  <a href="/" rel="home" title="rade">
                    <img src={logo} alt="rade" />
                  </a>
                </div>
                <div className="site_navigation">
                  <nav className="main_navigation">
                    <ul className="mastermenu">
                      <li className="menu_item">
                        <Link className="nav">Services</Link>
                        <ul className="sub_menu">
                          <li>
                            <a href="/commercial-cleaning">
                              Commercial Cleaning
                            </a>
                          </li>
                          <li>
                            <a href="/residential-cleaning">
                              Residential Cleaning
                            </a>
                          </li>
                          <li>
                            <a href="/specialized-cleaning">
                              Specialized Cleaning
                            </a>
                          </li>
                          <li>
                            <a href="/transport-and-logistics">
                              Transport & Logistics
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="menu_item">
                        <Link className="nav">Company</Link>
                        <ul className="sub_menu">
                          <li>
                            <a href="/about">About us</a>
                          </li>
                          <li>
                            <a href="/Our Team">Our Team</a>
                          </li>
                          <li>
                            <a href="/Gallery">Gallery</a>
                          </li>
                        </ul>
                      </li>
                      <li className="menu_item">
                        <Link className="nav">Contact</Link>
                        <ul className="sub_menu">
                          <li>
                            <a href="/contact">Contact Us</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                  <div className="right_social_icons">
                    <a
                      className="fa"
                      href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                      title="Facebook"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-facebook-f custom-icon"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                      title="Instagram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                      title="Tiktok"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile_header">
            <div className="container">
              <div className="mobile_row">
                <div className="site_branding">
                  <a href="/" rel="home" title="rade">
                    <img src={logo} alt="rade" />
                  </a>
                </div>
                <div className="open-menu" onClick={toggleNav}>
                  {/* <i class="fa-solid fa-x"></i> */}
                  {!isClick ? (
                    <i class="fa-solid fa-bars"></i>
                  ) : (
                    <i class="fa-solid fa-x"></i>
                  )}
                  {/* <i class="fa-solid fa-bars"></i>
                            <i class="fa-solid fa-x"></i> */}
                </div>
                {isNavVisible && (
                  <div className="site_navigation">
                    <nav className="main_navigation">
                      <ul className="mastermenu">
                        <li className="menu_item">
                          <a
                            className="nav"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent jumping to top
                              toggleMenu('services');
                            }}
                          >
                            Services
                          </a>
                          {openMenu === 'services' && (
                            <ul className="sub_menu">
                              <ul className="sub_menu">
                                <li>
                                  <a href="/commercial-cleaning">
                                    Commercial Cleaning
                                  </a>
                                </li>
                                <li>
                                  <a href="/residential-cleaning">
                                    Residential Cleaning
                                  </a>
                                </li>

                                <li>
                                  <a href="/transport-and-logistics">
                                    Transport & Logistics
                                  </a>
                                </li>
                                <li>
                                  <a href="/specialized-cleaning">
                                    Specialized Cleaning
                                  </a>
                                </li>
                              </ul>
                            </ul>
                          )}
                        </li>
                        <li className="menu_item">
                          <a
                            className="nav"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent jumping to top
                              toggleMenu('company');
                            }}
                          >
                            Company
                          </a>
                          {openMenu === 'company' && (
                            <ul className="sub_menu">
                              <li>
                                <a href="/about">About us</a>
                              </li>
                              <li>
                                <a href="/our team">Our Team</a>
                              </li>
                              <li>
                                <a href="/gallery">Gallery</a>
                              </li>
                            </ul>
                          )}
                        </li>
                        <li className="menu_item">
                          <a
                            className="nav"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent jumping to top
                              toggleMenu('contact');
                            }}
                          >
                            Contact
                          </a>
                          {openMenu === 'contact' && (
                            <ul className="sub_menu">
                              <li>
                                <a href="/contact">Contact Us</a>
                              </li>
                            </ul>
                          )}
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
          <DisplaySection>
            <div className="container">
              <div className="row">
                <ArticleShowcase></ArticleShowcase>
                {/* <div className="form">
                  <h3>Get Free Estimate</h3>
                  <form action="">
                    <div className="main_form">
                      <div className="name">
                        <input
                          type="text"
                          name="name"
                          id="name"
                          placeholder="Your Name*"
                        />
                      </div>
                      <div className="phone">
                        <input
                          type="tel"
                          name="phone"
                          id="phone"
                          placeholder="Phone Number"
                        />
                      </div>
                      <div className="choose_service">
                        <select
                          name="service"
                          id="service"
                          placeholder="Choose Service"
                        >
                          <option value="choose service">choose service</option>
                          <option value="House Cleaning">House Cleaning</option>
                          <option value="Office Cleaning">
                            Office Cleaning
                          </option>
                          <option value="Carpet Cleaning">
                            Carpet Cleaning
                          </option>
                        </select>
                      </div>
                      <div className="comment">
                        <textarea
                          name=""
                          id=""
                          maxLength="2000"
                          placeholder="Your Comment"
                        ></textarea>
                      </div>
                      <div className="button">
                        <button>Get A Quote</button>
                      </div>
                    </div>
                  </form>
                </div> */}
              </div>
            </div>
          </DisplaySection>
        </div>
      </Header>
      <main>
        <AboutMe>
          <div className="container">
            <div className="row">
              <div className="col-1">
                <a
                  href="https://www.freepik.com/free-photo/modern-residential-building_9192853.htm#fromView=search&page=1&position=0&uuid=74b17b00-7ca8-4bd7-918c-87aa7a244be3&query=residential"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={About} alt="cleaning" />
                </a>
              </div>
              <div className="col-2">
                <h1>
                  One-Stop Solution for Professional Facilities management
                </h1>
                <p>
                  At Rade Integrated Services Ltd, we take pride in delivering
                  exceptional facilities management services tailored to meet
                  the diverse needs of our valued clients. <br />
                  With strong commitment to excellence, reliability and customer
                  satisfaction, we have established ourselves as a premier
                  facilities management service provider in the industry.
                </p>
                <Link to="/about" className="btn">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </AboutMe>
        <WhyChooseUs>
          <div className="container">
            <div className="row">
              <div className="col-1">
                <h3>Why Choose Rade?</h3>
                <h1>Expert Management, Exceptional Environments </h1>
                <p>
                  Fragmented supplier management is a thing of the past. Rade
                  integrated services Ltd brings your entire facility’s needs
                  under one roof, reducing costs and elevating quality through a
                  single, coordinated point of contact.
                </p>
                <br />
                <br />
                <Link to="/about" className="btn">
                  Read More
                </Link>
              </div>
              <div className="col-2">
                <a
                  href="https://www.freepik.com/free-photo/close-up-hand-filling-document_25128664.htm#fromView=search&page=1&position=41&uuid=d7a6599a-0c39-4253-812a-9e59ec5e662b&query=facility+management"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={Facilities} alt="" />
                </a>
              </div>
              <div className="col-3">
                <div className="whychoose pro">
                  <img src={professional} alt="" width="50" height="50" />
                  <h2>Customized for Excellence</h2>
                  <p>From hygiene-critical wards to international airports.</p>
                </div>
                <div className="whychoose customize">
                  <img src={custom} alt="" width="50" height="50" />
                  <h2>Reduced Complexity</h2>
                  <p>Fewer contracts, better results.</p>
                </div>
                <div className="whychoose pricing">
                  <img src={price} alt="" width="50" height="50" />
                  <h2>Strategic Impact</h2>
                  <p>
                    We optimize your environment so you can focus on your
                    mission.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </WhyChooseUs>
        <MapSection>
          <div className="container">
            <h2>Areas We Cover</h2>
            <p>
              All cities in South Yorkshire, West Yorkshire, North Yorkshire,
              East Yorkshire, East Midlands and Greater Manchester.
            </p>
            <div class="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d607387.8547864086!2d-1.5231894547241804!3d53.51118315676702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sng!4v1746381350417!5m2!1sen!2sng"
                allowfullscreen=""
                loading="lazy"
                reerrorpolicy="no-referrer-when-downgrade"
                title="map"
              ></iframe>
            </div>
          </div>
        </MapSection>
      </main>
      <Footer></Footer>
    </>
  );
};



export default Home;
